import React, { useState } from "react";
import { Autocomplete, Box, InputAdornment, TextField } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import OTPmodal from "../Modal/OTPmodal";

const Searchbar = ({ placeholder, onChange }) => {
  const [inputValue, setInputValue] = useState("");

  const handleClearClick = () => {
    setInputValue("");
    onChange({ target: { value: "" } });
  };

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Autocomplete
        freeSolo
        options={[]}
        value={inputValue}
        onInputChange={(event, newValue) => {
          setInputValue(newValue);
          onChange(event);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlinedIcon />
                </InputAdornment>
              ),
              endAdornment: inputValue ? (
                <InputAdornment position="end">
                  <CancelIcon
                    onClick={handleClearClick}
                    style={{ cursor: "pointer" }}
                  />
                </InputAdornment>
              ) : null,
            }}
            sx={{
              border: "1px solid #E8E8E8",
              bgcolor: "#FFFFFF",
              borderRadius: "10px",
              width: { sm: "100%", md: "100%" },
            }}
          />
        )}
      />
      <OTPmodal />
    </Box>
  );
};

export default Searchbar;
